<template>
  <div class="promo">
    <img src="@/assets/images/promotion/main_visual.jpg">
    <div class="loca__benefit-container loca__benefit-promotion">
      <h2 class="loca__benefit-title">
        LOCA만의 <strong>파격 프로모션</strong>
      </h2>
      <badger-accordion ref="accordion">
        <badger-accordion-item>
          <template slot="header">
            <div class="benefit__header">
              <div class="benefit__title-sub">
                혜택 <strong>하나!</strong>
              </div>
              <div class="benefit__title">
                10만원 캐시백!
              </div>
            </div>
          </template>
          <template slot="content">
            <div class="over-type">
              <img src="@/assets/images/promotion/content_1_title.jpg">
            </div>
            <div class="benefit__content">
              <div class="content__body">
                <p><strong>행사기간</strong><br>
                  2020년 11월 1일(일)~11월 30일(월) *응모일기준
                </p>
                <p><strong>대상카드</strong><br>
                  LOCA CLASSIC + LOCA for 시리즈
                </p>
                <p><strong>행사대상</strong><br>
                  행사기간직전 6개월(2020.4.30~10.31)동안<br>
                  롯데카드(개인신용, 체크, 하이브리드)결제이력 포함 및 탈회 이력이 없는 회원<br>
                  <span class="small">
                    * 온라인(PC,모바일)을 통해 대상카드를 발급받은 회원만<br> 행사대상이 됩니다.<br>
                    * 오프라인채널(설계사등) 또는 롯데카드연회비캐시백이벤트<br>(롯데카드홈페이지등) 경로통해 발급받은 회원은 대상에서 제외됩니다.
                  </span>
                </p>
                <p><strong>행사내용</strong><br>
                  1. 아래 '응모하기'를 통해 이벤트에 응모하고 대상카드 이용<br>
                  2. 아래 3개월 미션 달성 시 총 10만원 캐시백 제공<br>
                  * 일시불 및 할부합산 이용금액에 따라 제공<br>
                  <table class="content__body-table">
                    <tr>
                      <th>미션</th>
                      <th>합산이용금액</th>
                      <th>이용기간</th>
                      <th>캐시백금액</th>
                    </tr>
                    <tr>
                      <td>①</td>
                      <td>50,000원</td>
                      <td>2020/11/1 ~ 11/30</td>
                      <td>50,000원</td>
                    </tr>
                    <tr>
                      <td>②</td>
                      <td>30,000원</td>
                      <td>2020/12/1 ~ 12/31</td>
                      <td>30,000원</td>
                    </tr>
                    <tr>
                      <td>③</td>
                      <td>20,000원</td>
                      <td>2021/1/1 ~ 1/31</td>
                      <td>20,000원</td>
                    </tr>
                  </table>
                  <span class="small">
                    * 미션을 11월~1월 연속으로 달성하지 않아도 조건을 충족한 구간의 헤택이 제공됩니다.<br>
                    <b>(예시)</b><br>
                    - 11월 한 달만 미션 달성 시(①) : 총 5만원 캐시백<br>
                    - 12월, 1월 미션 달성 시 (②+③) : 총 5만원 캐시백 (2만원+3만원)<br>
                    - 11월~1월 미션 모두 달성 시 (①+②+③) : 총 10만원 캐시백
                  </span>
                </p>
                <p><strong>캐시백 지급</strong><br>
                  미션 달성 다음 달 롯데카드에 등록된 계좌로 지급<br>
                  - 미션 ① 달성 시 : 2020년 12월 21일(월) 이후<br>
                  - 미션 ② 달성 시 : 2021년 1월 25일(월) 이후<br>
                  - 미션 ③ 달성 시 : 2021년 2월 22일(월) 이후
                </p>
              </div>
            </div>
          </template>
        </badger-accordion-item>
        <badger-accordion-item>
          <template slot="header">
            <div class="benefit__header">
              <div class="benefit__title-sub">
                혜택 <strong>둘!</strong>
              </div>
              <div class="benefit__title">
                5개월간 전월실적 50만원 인하!
              </div>
            </div>
          </template>
          <template slot="content">
            <img src="@/assets/images/promotion/content_2.jpg">
            <div class="benefit__content">
              <div class="content__body">
                <p><strong>대상</strong><br>
                  기간 내 LOCA 카드 소지 회원
                </p>
                <p><strong>내용</strong><br>
                  LOCA카드를 최초로 소지하신 월 포함 5개월 간<br>
                  LOCA카드 전월실적 기준을 150만원에서 100만원으로<br>낮춰드려요
                </p>
                <p><strong>기간</strong><br>
                  2020년 11월 30일까지 *카드 발급 월 기준<br>
                  <span class="small">예시)<br>
                  1.20년 10월 카드 발급 시 21년 2월까지 혜택 적용<br>
                  2. 20년 11월 카드 발급 시 21년 3월까지 혜택 적용
                  </span>
                </p>
              </div>
            </div>
          </template>
        </badger-accordion-item>
        <badger-accordion-item>
          <template slot="header">
            <div class="benefit__header">
              <div class="benefit__title-sub">
                혜택 <strong>셋!</strong>
              </div>
              <div class="benefit__title">
                금융서비스 이용금액 실적 합산!
              </div>
            </div>
          </template>
          <template slot="content">
            <img src="@/assets/images/promotion/content_3.jpg">
            <div class="benefit__content">
              <div class="content__body">
                <p><strong>대상</strong><br>
                  기간 내 LOCA 카드 소지 회원
                </p>
                <p><strong>내용</strong><br>
                  LOCA카드 회원의 전월실적에 금융(현금서비스,카드론)<br>이용금액 포함
                </p>
                <p><strong>기간</strong><br>
                  2020.09.10(목) ~ 12.31(목) *서비스 적용일 기준
                </p>
                <p><strong>기준</strong><br>
                  금융서비스 신청한 달이 30일인 경우<br>
                  전월실적 합산기준=이용금액x이용기간/30일(전체일수)<br>
                  *월 평균 금융서비스 이용금액이 실적에 포함되며,<br>
                  중도 상환되는 금액은 이용금액에서 차감됩니다.
                </p>
                <p class="small">
                  9월 3일 100만원 현금서비스 이용 후 11월 5일 상환 시<br>
                  → 9월 실적 포함 금액 : 933,333원 (1,000,000원x28일) ÷ 30일))<br>
                  → 10월 실적 포함 금액 : 1,000,000원 (1,000,000원x31일) ÷ 31일))<br>
                  → 11월 실적 포함 금액 : 133,333원 (1,000,000원x4일) ÷ 30일))<br>
                </p>
              </div>
            </div>
          </template>
        </badger-accordion-item>
      </badger-accordion>
    </div>
    <div class="footer gate__footer">
      <div class="caution">
        <h3>유의사항</h3>
        <div class="caution-inner">
          <ul class="footer__text">
            <li>LOCA 시리즈 카드 지난 달 통합실적 기준을 충족하지 못한 경우, LOCA for 카드 할인혜택이 제공되지 않습니다.</li>
            <li>LOCA 카드로 LOCA for 할인혜택을 받는 경우, LOCA for 카드 할인한도 내에서 혜택이 제공됩니다.</li>
            <li>본인 회원이 소지한 LOCA 시리즈 카드 기준, 정상적으로 이용이 가능한 카드만 할인 혜택을 이용할 수 있습니다.</li>
            <li>상기 프로모션은 중복 혜택 적용이 가능합니다.</li>
          </ul>
        </div>
        <div class="caution-inner">
          <h4>LOCA만의 파격 프로모션 하나!</h4>
          <ul class="footer__text">
            <li>행사기간 직전 6개월 동안의 결제 이력은 본인 명의의 롯데 개인신용카드 전체(대상카드포함)의 결제 이력을 의미합니다.</li>
            <li>일시불 및 할부 이용 금액에 한하며, 단기 카드대출(현금서비스), 장기 카드대출(카드론), 각종 수수료 및 이자(할부 수수료, 카드대출 이자 등), 연체료, 연회비 등 일시불<br> 및 할부 이용금액 이외의 금액은 제외됩니다.</li>
            <li>응모시점에 관계없이, 이용금액 산정기간 동안의 금액이 합산되어 산정됩니다. </li>
            <li>응모 시 입력한 휴대전화번호와 롯데카드에 등록 된 휴대 전화번호가 다를 경우 혜택이 제공되지 않습니다. 응모 전 롯데카드에 등록된 휴대전화번호를 확인해주시기 바랍니다.</li>
            <li>롯데카드의 다른 이용유도 프로모션(캐시백, 포인트적립, 쿠폰제공 등) 혜택과 중복 적용되지 않으며, 혜택이 큰<br> 금액만 적용됩니다.</li>
            <li>이용금액 산정은 승인 시점 기준으로 적용됩니다. 다만,<br> 해외 결제 건 및 무승인 결제 건(예: 대중교통, 이동통신 등 자동납부 결제 건 등)의 경우 매출 전표 접수시점 기준으로 적용됩니다.</li>
            <li>캐시백 제공일 이전에 대상카드 해지, 탈회시 혜택이<br> 제공되지 않습니다.</li>
            <li>타 제휴사 이벤트(토스, 카드고릴라 등) 연회비 캐시백 <br>이벤트 등 롯데카드 타 이벤트 혜택과 중복적용 불가능합니다.</li>
            <li>캐시백되는 달의 카드 이용 금액이 캐시백 금액보다<br> 적을 경우, 다음 달 이용 금액에서 잔여 캐시백만큼<br> 자동차감 됩니다.</li>
            <li>카드사 및 제휴사의 사정으로 변경 중단 될 수 있으며,<br> 그 내용을 사전에 알려드립니다.</li>
          </ul>
        </div>
        <div class="caution-inner">
          <h4>LOCA만의 파격 프로모션 둘!</h4>
          <ul class="footer__text">
            <li>롯데카드 단기 카드대출, 장기 카드대출은 취급 수수료 및 중도상환수수료가 없습니다.</li>
            <li>실적 합산 금액은 금융 상품 이용 일자에 따라 다를 수 있습니다.</li>
            <li>계약을 체결하기 전 상세한 안내는 상품 설명서와 약관을 참고바랍니다.</li>
            <li>단기 카드대출(현금서비스), 장기 카드대출(카드론)의 <br>최고 이자율은 23.5%로 회원님의 신용도에 따라 차등 적용됩니다.</li>
            <li>이 이벤트는 롯데카드 사정으로 변경 및 중단될 수 있으며,<br> 그 내용은 사전에 알려드립니다.</li>
          </ul>
        </div>
      </div>
      <div class="caution-inner">
        <ul class="footer__text">
          <li>카드출시일: 2020년7월10일 -연회비: <br>LOCA CLASSIC 20,000원, LOCA for 5종카드20,000원</li>
          <li>서비스 제공 업종은 롯데카드에 등록된 가맹점 업종<br> 기준으로 합니다.</li>
          <li>카드신청 전 이용조건 및 상세혜택은 홈페이지 또는 상품설명서, 약관을 확인하시기 바랍니다.</li>
          <li>연체이자율: 회원별·이용상품별 약정 이율 + 최대3%, 법정최고금리(연24%) 이내</li>
          <li>단, 연체발생 시점에 약정 이율이 없는 경우 아래와 같이<br> 약정 이율을 적용</li>
          <li>일시불 거래 연체 시 : 거래 발생 시점의 최소 기간(2개월) 유이자 할부 금리</li>
          <li>무이자 할부 거래 연체 시 : 거래 발생 시점의 동일한 할부 계약기간의 유이자 할부 금리</li>
          <li>대출시점 연체발생, 신용등급 하락, 대출증가 등 신용위험, 상환능력이 약화되는 경우 대출이 불가할 수 있습니다.<br>
          * 취급수수료 및 중도상환수수료 없음.</li>
          <li>그 외의 경우 : 약정이율은 상법상 상사법정이율과 상호금융 가계자금대출금리* 중 높은 금리 적용<br>
          * 한국은행에서 매월 발표하는 가장 최근의 비은행 금융기관 가중평균 대출금리 (신규대출기준)</li>
        </ul>
      </div>
      <div class="deliberation">
        <div>신용카드 남용은 가계경제에 위협이 됩니다.</div>
        <div>필요 이상으로 카드를 발급받을 경우 개인 신용등급 또는 신용평점, 이용한도 등에 영향을 미칠 수 있습니다. </div>
        <div>장기 카드대출 이용 시 신용등급에 부정적 영향을 미칠 수 있습니다.</div>
        <div>여신금융 상품 이용 시 귀하의 신용등급 또는 개인신용평점이 하락할 수 있습니다.</div>
        <div>여신금융 협회심의필<br>제 2020-C1H-08729호<br> (2020.09.28 ~ 2020.12.31)</div>
      </div>
      <div class="copyright">
        <p class="logo">
          <img src="@/assets/images/footer_logo.png" alt="">
        </p>
        <p>
          서울특별시 종로구 새문안로 76 롯데카드  I  ㈜대표이사 : 조좌진<br>
          대표전화 : 1588-8100  I  사업자등록번호 : 120-81-54231<br>
          통신판매신고번호 : 제-2010-서울중구-0087호<br>
          COPYRIGHTⓒLOTTECARD CO. LTD.<br>
          All Rights Reserved.
        </p>
      </div>
    </div>
    <div class="promo__fixed">
      <a :href="setBenefit">
        <img src="@/assets/images/promotion/fixed_1.jpg">
      </a>
      <a :href="setApply">
        <img src="@/assets/images/promotion/fixed_2.jpg">
      </a>
    </div>
  </div>
</template>

<script>
import bidMixin from '@/mixin/bidMixin'
import { BadgerAccordion, BadgerAccordionItem } from 'vue-badger-accordion'
export default {
  name: 'Locapromotion',
  mixins: [bidMixin],
  components: {
    BadgerAccordion,
    BadgerAccordionItem
  },
  data () {
    return {
      size: null,
      bid: null,
      urlCheck: [
        {
          key: 'naver_sub_bs',
          param: 'evn_bult_seq=6291&cco_evn_gubun=naver_sub_bs_loca',
          mobileParam: 'evn_bult_seq=6281&cco_evn_gubun=naver_sub_bs_loca'
        },
        {
          key: 'naversmart_da',
          param: 'evn_bult_seq=6292&cco_evn_gubun=naversmart_da_loca',
          mobileParam: 'evn_bult_seq=6282&cco_evn_gubun=naversmart_da_loca'
        },
        {
          key: 'navergfa_da',
          param: 'evn_bult_seq=6293&cco_evn_gubun=navergfa_da_loca',
          mobileParam: 'evn_bult_seq=6283&cco_evn_gubun=navergfa_da_loca'
        },
        {
          key: 'kakaobizboard_da',
          param: 'evn_bult_seq=6294&cco_evn_gubun=kakaobiz_da_loca',
          mobileParam: 'evn_bult_seq=6284&cco_evn_gubun=kakaobiz_da_loca'
        },
        {
          key: 'kakaomoment_da',
          param: 'evn_bult_seq=6295&cco_evn_gubun=kakaomoment_da_loca',
          mobileParam: 'evn_bult_seq=6285&cco_evn_gubun=kakaomoment_da_loca'
        },
        {
          key: 'google_sa',
          param: 'evn_bult_seq=6296&cco_evn_gubun=google_sa_loca',
          mobileParam: 'evn_bult_seq=6286&cco_evn_gubun=google_sa_loca'
        },
        {
          key: 'naver_sa',
          param: 'evn_bult_seq=6297&cco_evn_gubun=naver_sa_loca',
          mobileParam: 'evn_bult_seq=6287&cco_evn_gubun=naver_sa_loca'
        },
        {
          key: 'kakao_sa',
          param: 'evn_bult_seq=6298&cco_evn_gubun=kakao_sa_loca',
          mobileParam: 'evn_bult_seq=6288&cco_evn_gubun=kakao_sa_loca'
        },
        {
          key: 'fbook_sns',
          param: 'evn_bult_seq=6299&cco_evn_gubun=fbook_sns_loca',
          mobileParam: 'evn_bult_seq=6289&cco_evn_gubun=fbook_sns_loca'
        },
        {
          key: 'insta_sns',
          param: 'evn_bult_seq=6300&cco_evn_gubun=insta_sns_loca',
          mobileParam: 'evn_bult_seq=6290&cco_evn_gubun=insta_sns_loca'
        },
        {
          key: 'incorporation_card',
          param: 'evn_bult_seq=6308&cco_evn_gubun=corporate_loca',
          mobileParam: 'evn_bult_seq=6309&cco_evn_gubun=corporate_loca'
        }
      ]
    }
  },
  mounted () {
    setTimeout(() => {
      this.$refs.accordion.open(0)
    }, 300)
    this.setSize()
    window.addEventListener('resize', this.setSize)
  },
  computed: {
    setBenefit () {
      let setBid = ''
      if (this.bid !== '') {
        setBid = this.bid
      }
      return `https://${this.$mq === 'sm' ? 'm' : 'www'}.lottecard.co.kr/app/LPCDXAD_V100.lc?loca=classic&top=0&bId=${setBid}`
    },
    setApply () {
      let setParam = ''
      if (this.$route.query.utm_source) {
        const paramFind = this.urlCheck.filter((item) => {
          return item.key === this.$route.query.utm_source
        })
        if (paramFind.length > 0) {
          setParam = this.$mq === 'sm' ? paramFind[0].mobileParam : paramFind[0].param
        }
      }
      return `https://${this.$mq === 'sm' ? 'm' : 'www'}.lottecard.co.kr/app/LPBNFDA_V540.lc?${setParam}`
    }
  },
  methods: {
    setSize () {
      this.size = screen.width / 36
      if (this.size >= 14) {
        this.size = 14
      }
      document.documentElement.style.fontSize = this.size + 'px'
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';
html {
  background: #f7f5f8;
}
body {
  padding: 0;
}
</style>
